// extracted by mini-css-extract-plugin
export var readonly = "_h8-1";
export var star = "_h8-0";